import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import { jwtDecode } from "jwt-decode";
import { initReactI18next } from "react-i18next";

const getLanguageFromToken = () => {
  const token = localStorage.getItem("token"); // Or use sessionStorage or any other storage
  if (!token) {
    return "en"; // Return default language if no token is found
  }
  try {
    const decodedToken = jwtDecode(token);
    // Assuming your token payload has a 'language' field
    return decodedToken.language || "en"; // Return language from token or 'en' if not set
  } catch (e) {
    console.error("Failed to decode token:", e);
    return "en"; // Return default language if decoding fails
  }
};

const language = getLanguageFromToken();
i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    fallbackLng: language,
    ns: [
      "menus",
      "buttons",
      "company",
      "customer",
      "packages",
      "destinationpackage",
      "destinationdelivery",
      "common",
      "options",
      "history",
      "error",
      "companybill",
      "customerbill",
      "dashboard",
    ],
    defaultNS: "menus",
    // debug: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
